module.exports = __webpack_public_path__ + "static/media/fryktelig.a214e5d8.m4a";